import DeliveryNoteIcon from 'assets/dialogue-avatar-delivery-note.svg';
import { DialogueCardData, DialogueType } from 'models/DialogCard';
import { ServiceCode, TimeWindow, TimeWindowOnTimeStatusEnum } from 'models/shipments';

const { EARLIER, LATE } = TimeWindowOnTimeStatusEnum;

interface DialogueCardTimes {
  [key: string]: DialogueCardData;
}

const TimeWindowCardsByService: { [key in ServiceCode | 'default']: DialogueCardTimes } = {
  default: {
    [EARLIER]: {
      analyticsId: 'timeWindowEarly',
      type: DialogueType.DELIVERY_NOTE,
      icon: <DeliveryNoteIcon />,
      title: 'We’re running ahead of schedule today',
      content: <p>Your parcel will likely arrive sooner than expected.</p>,
    },
    [LATE]: {
      analyticsId: 'timeWindowLate',
      type: DialogueType.DELIVERY_NOTE,
      icon: <DeliveryNoteIcon />,
      title: 'We’re running behind schedule today',
      content: <p>Your parcel will likely arrive later than expected.</p>,
    },
  },
  [ServiceCode.WINE]: {
    [EARLIER]: {
      analyticsId: 'timeWindowEarlyWine',
      type: DialogueType.DELIVERY_NOTE,
      icon: <DeliveryNoteIcon />,
      title: 'We’re running ahead of schedule today',
      content: (
        <>
          <p>This parcel will likely arrive sooner than expected.</p>
          <p>
            {`We can only hand over this parcel to the person it’s addressed to. They’ll need to show valid ID proving they’re at least 18 years old and sign for the parcel.`}
          </p>
        </>
      ),
    },
    [LATE]: {
      analyticsId: 'timeWindowLateWine',
      type: DialogueType.DELIVERY_NOTE,
      icon: <DeliveryNoteIcon />,
      title: 'We’re running behind schedule today',
      content: (
        <>
          <p>This parcel will likely arrive later than expected. </p>
          <p>
            {`We can only hand over this parcel to the person it’s addressed to. They’ll need to show valid ID proving they’re at least 18 years old and sign for the parcel.`}
          </p>
        </>
      ),
    },
  },
  [ServiceCode.S8]: {
    [EARLIER]: {
      analyticsId: 'timeWindowEarlyS8',
      type: DialogueType.DELIVERY_NOTE,
      icon: <DeliveryNoteIcon />,
      title: 'We’re running ahead of schedule today',
      content: (
        <>
          <p>This parcel will likely arrive sooner than expected.</p>
          <p>
            We can only hand over this parcel to the person it’s addressed to. They’ll need to show valid ID and sign
            for the parcel.
          </p>
        </>
      ),
    },
    [LATE]: {
      analyticsId: 'timeWindowLateS8',
      type: DialogueType.DELIVERY_NOTE,
      icon: <DeliveryNoteIcon />,
      title: 'We’re running behind schedule today',
      content: (
        <>
          <p>This parcel will likely arrive later than expected. </p>
          <p>
            We can only hand over this parcel to the person it’s addressed to. They’ll need to show valid ID and sign
            for the parcel.
          </p>
        </>
      ),
    },
  },
};

export function getTimeWindowCard(timeWindow: TimeWindow | null, serviceCode?: string | null) {
  const { passedWindow, onTimeStatus } = timeWindow || {};
  if (passedWindow || !onTimeStatus) return null;
  const serviceCards = TimeWindowCardsByService[serviceCode as ServiceCode] || TimeWindowCardsByService.default;

  return serviceCards[onTimeStatus] || null;
}
